import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import styles from './Search.module.css';

const AIEduSearch = ({
    value,
    setValue,
    placeholder,
    searchHandler,
    handleInputKeyDown,
}) => {
    return (
        <IconField iconPosition='right'>
            <InputText
                className={styles.patentPortal_Search}
                type='text'
                value={value}
                placeholder={placeholder}
                onKeyDown={handleInputKeyDown}
                onChange={(e) => setValue(e.target.value)}
            />
            <InputIcon
                className='pi pi-search cursor-pointer'
                onClick={searchHandler}
            />
        </IconField>
    );
};

export default AIEduSearch;
